<template>
  <div ref="mycontentRef" class="mycontent" style="height: 100%;">
    <div v-show="!isLoading" style="height: 100%;">
      <div v-show="projectList.length" style="height: 100%;display: flex;flex-direction: column;padding:0 40px;" :style="{padding:padding?padding:'0 40px'}">
        <div style="height:calc(100% - 40px)">
          <pl-table
              :id="'dltable'+tableId"
              :class="(sortable||sortableColumns)?'sortableClass':''"
              :border="false"
              :height="tableHeight"
              ref="eltable"
              :key="'dltablekey'+tableId"
              @sort-change="sortChange"
              @row-click="rowClick"
              :data="projectList"
              :cell-style="cellStyleMethod"
              :row-style="rowStyle"
              :header-cell-style="headCellStyle"
              :row-hegit="rowHegit"
              :use-virtual="useVirtual"
              :excess-rows="excessRows"
              :default-sort="defaultSort"
              :stripe="false"
              showBodyOverflow="title"
              showHeaderOverflow="title"
              size="mini"
              :show-summary="showSummary"
              :summary-method="summaryMethod"
          >
            <!--tableId为1时不启用fixed-->
            <pl-table-column
                v-for="item in showColoums"
                :min-width="columnsMin(item)"
                :width="columnsfixed(item)"
                :prop="item"
                :fixed="(fixedColumns.indexOf(item)!==-1?true:false)||(fixedRightColumns&&fixedRightColumns.indexOf(item)!==-1?'right':false)"
                :key="item+sortCount"
                :sortable="sortable?'custom':(sortableColumns?sortableColumns.indexOf(item)!==-1:false)"
            >
              <!--表头如果有单位的，强制换行-->
              <template #header>
                <div>
                  {{ columnLabel(item) }}<br/> {{ columnLabelLast(item) }}
                </div>
              </template>
              <template #default="scope">
<!--                &&scope.row[tableColumnCustomConfig.showRule.key]==tableColumnCustomConfig.showRule.value-->
                <div v-if="tableColumnCustomConfig&&tableColumnCustomConfig.hasOwnProperty(item)">
                  <div style="display: flex;align-items: center;" v-if="tableColumnCustomConfig[item].type=='popover'"  @click.stop>
                    <div style="margin-right:5px;">{{ toQfNumber(scope.column.property, scope.row[scope.column.property], scope) }}</div>
                    <el-popover v-if="scope.row[tableColumnCustomConfig[item].showRule.key]==tableColumnCustomConfig[item].showRule.value" :ref="'unusual'+scope.row[scope.column.property]" :popper-options="{ boundariesElement: 'viewport', removeOnDestroy: true }" :popper-class="tableColumnCustomConfig[item].popoverDatas.length?'unusual-popover':'unusual-popover'" trigger="hover" placement="top-start" offset="30" @show="unusualShow(item, scope.row[scope.column.property],true)">
                      <div v-if="tableColumnCustomConfig[item].popoverDatas.length>0" style="max-height:200px;overflow:scroll;">
                        <div v-for="col in tableColumnCustomConfig[item].popoverDatas" style="margin-top:8px;margin-bottom:16px;">
                          <div style="display: flex;justify-content: space-between;">
                            <div style="display:flex;">{{col.project_remark}}
                              <div style="margin-left: 10px;">{{col.stat_time}}</div>
                            </div>
                            <div>{{col.username}}</div>
                          </div>
                          <div style="display: flex;margin-top:4px;">{{col.project_comment}}</div>
                        </div>
                      </div>
                      <div v-else >暂无备注</div>
                      <!--                    <div slot="reference" class="name-wrapper" style="display: flex;align-items: center;cursor:pointer;" @mouseenter="unusualShow(item, scope.row[scope.column.property],true)" @mouseleave="unusualShow(item, scope.row[scope.column.property],false)">-->
                      <div slot="reference" class="name-wrapper" style="display: flex;align-items: center;cursor:pointer;">
                        <img src="../assets/img/orderWariningTips.png" width="13" height="15">
                      </div>
                    </el-popover>
                  </div>
                  <div style="display: flex;align-items: center;" v-if="tableColumnCustomConfig[item].type=='colorText'">
                    <div :class="tableColumnCustomConfig[item].colorClass">{{scope.row[scope.column.property]}}</div>
                  </div>
                  <div style="display: flex;align-items: center;" v-if="tableColumnCustomConfig[item].type=='indicator'">
                    <div class="detail-text-2">
                      <div :style="{background:tableColumnCustomConfig[item].colorMap[scope.row[scope.column.property]]?tableColumnCustomConfig[item].colorMap[scope.row[scope.column.property]]:'#409EFF'}" class="clue_state_0"></div>
                      <div style="flex:1;">{{scope.row[scope.column.property]}}</div>
                    </div>
                  </div>
                  <div v-if="tableColumnCustomConfig[item].type=='tag'&&scope.row[scope.column.property]">
                    <el-tag v-if="split2Array(scope.row[scope.column.property]).length==1" size="small" :type="tableColumnCustomConfig[item].tagTypeMap instanceof Object ?tableColumnCustomConfig[item].tagTypeMap[scope.row[scope.column.property]] :tableColumnCustomConfig[item].tagTypeMap">{{scope.row[scope.column.property]}}</el-tag>
                    <div style="display: flex;flex-direction: column;align-items: flex-start;padding-top:4px;" v-else>
                      <el-tag v-for="tagItem in split2Array(scope.row[scope.column.property])" size="small" :type="tableColumnCustomConfig[item].tagTypeMap instanceof Object ?tableColumnCustomConfig[item].tagTypeMap[scope.row[scope.column.property]] :tableColumnCustomConfig[item].tagTypeMap" style="margin-bottom: 4px;">{{tagItem}}</el-tag>
                    </div>
                  </div>
                  <div style="display: flex;align-items: center;justify-content: space-between" v-if="tableColumnCustomConfig[item].type=='edit'">
                    <div class="detail-text-2" style="justify-content: space-between;width: 100%;">
                      <div>{{scope.row[scope.column.property]}}</div>
                      <el-button size="mini" style="padding:4px 6px;font-size: 10px;" class="t-blue" @click.stop="$emit('editClick',scope.row)">编辑</el-button>
                    </div>
                  </div>

                </div>
                <div v-else :style="{ fontSize: '14px' }">
                  {{ toQfNumber(scope.column.property, scope.row[scope.column.property], scope) }}
                </div>
              </template>
            </pl-table-column>
            <pl-table-column
              v-if="exportBtn"
              width="200"
              prop="exportBtn">
              <template #header>
                <div>操作</div>
              </template>
              <template #default="scope">
                <el-button @click="$emit('exportBtnClick', scope.row)" type="text" size="small">导出明细</el-button>
              </template>
            </pl-table-column>
          </pl-table>
        </div>
        <!-- 分页控制器 -->
        <div style="width:100%;height:40px;display: flex;justify-content: space-between;margin-top:20px;">
          <div
              style="padding: 2px 5px;line-height: 28px;font-size: 12px;font-family: 'SourceHanSansSC-Regular'">
            共 <span style="color: #1473E3">{{ textFormat(totalnums) }}</span> 条数据
          </div>
          <el-pagination v-if="pagination" background layout="prev, pager, next" @current-change="currentChange"
                         :small="isSmallPage"
                         :page-size="pagesize"
                         :current-page="pageNumber" :total="totalnums" style="">
          </el-pagination>
        </div>
      </div>
      <div v-show="!projectList.length&&!firstLoading" style="height:100%;">
        <div
            style="height: 100%;width: 100%;display: flex;align-items: center;justify-content: center;font-weight: 400;line-height: 24px;color: #606266;font-size: 12px;">
          ——暂无数据——
        </div>
      </div>
    </div>

    <div v-if="isLoading">
      <el-skeleton :loading="isLoading" style="width: 100%;margin-left: 40px" animated>
        <template #template>
          <el-skeleton-item variant="rect" style="width: calc(100% - 80px); height: 100px"/>
          <div>
            <el-skeleton-item v-for="item in skeletonRows" :key="'loding'+item" variant="rect"
                              style="width:calc(100% - 80px);height: 62px"/>
            <div
                style="display: flex;align-items: center;justify-content: space-between;height: 60px;width: calc(100% - 80px)">
              <el-skeleton-item variant="rect" style="width: 10%;height: 62px;margin-right: auto"/>
              <el-skeleton-item v-if="tableId==0" variant="rect" style="width: 400px;height: 62px;margin-left: 0;"/>
            </div>
          </div>
        </template>
      </el-skeleton>
    </div>
  </div>
</template>

<script>
import Sortable from 'sortablejs';
import {textFormat} from "../utils/util";

/**
 *
 //列表相关
 @row-click 点击列表某个item事件
 project-list-dl 表格列表内容

 //列和表头相关
 @column-drop 表头拖动排序事件
 show-coloums-dl 显示的列（即表头显示的）
 column_mapper 所有的列枚举（包含未在表头显示的）

 //排序相关
 @sort-change 排序变化事件
 sort-column-name-dl 排序的名称
 sort-column-order-dl 排序的规则

 //页面控制相关
 @current-change  当前页改变事件
 totalnums-dl 总页数
 pagesize-dl 每页页数
 page-number-dl 当前页
 */

export default {
  name: "CustomTable",
  props: [
    "projectListDl",
    "showColoumsDl", "column_mapper",
    "sortColumnNameDl", "sortColumnOrderDl",
    "totalnumsDl", "pagesizeDl", "pageNumberDl",
    "fixedColumns",//固定的表头的列表
    "fixedRightColumns",
    "tableId",
    "sortable",
    "sortableColumns",
    "pagination",
    "isLoadingDl",
    "useVirtual",
    "rowHegit",
    "disableDrag",
    "tableColumnCustomConfig",
    "customTabelHeightOffset",
    "customColumnWidth",
    "defaultSort",
    "isSmallPage",
    "fixedHeight",
    "padding",
    "showSummary",
    "summaryMethod",
    "exportBtn"
  ],
  data() {
    return {
      firstInitHeight:true,
      isLoading: true,
      sortCount: 0,//在拖动改变列顺序时，为了更新列，需要改变表头的key，从而触发更新
      projectList: [],
      showColoums: [],
      sortColumnName: "",
      sortColumnOrder: "",
      totalnums: 0,
      pagesize: 10,//一页数据的行数
      pageNumber: 1,
      screenHeight: 0,
      tableHeight: 0,
      firstLoading: true,
      excessRows:2,//可视区域上方和下方额外渲染的行数，行数越多表格接替渲染效果越好，但越耗性能
    }
  },
  created() {
    this.textFormat = textFormat
      this.tableHeight = document.body.clientHeight - this.getCustomTabelHeightOffset
    // console.log('create!!')
  },

  updated() {
    // if(this.firstInitHeight&&this.$refs.mycontentRef.clientHeight){
    //   this.firstInitHeight = false
    //   console.log('更新一次高度')
    if(!this.fixedHeight){
      this.setHeight()
    }

  },

  mounted() {
    if(!this.fixedHeight){
      window.addEventListener("resize",()=>{
        // console.log('resize')
        this.setHeight()
      })
    }else{
      this.setHei(this.fixedHeight+'px')
    }

    // window.onresize = () => {
    //   console.log('window.onresize',this.tableId)
    //   that.setHeight()
    //   // return (() => {
    //   //   that.setHeight()
    //   // })()
    // }

    this.projectList = this.projectListDl
    this.showColoums = this.showColoumsDl
    this.sortColumnName = this.sortColumnNameDl
    this.sortColumnOrder = this.sortColumnOrderDl
    this.totalnums = this.totalnumsDl
    this.pagesize = this.pagesizeDl
    this.pageNumber = this.pageNumberDl
    this.isLoading = this.isLoadingDl
    if(!this.disableDrag){
      this.$nextTick(()=>{
        this.columnDrop();
      })
    }
      // this.getTableAction()
  },
  computed: {
    getCustomTabelHeightOffset(){
      return this.customTabelHeightOffset ? this.customTabelHeightOffset : 320
    },
    skeletonRows() {
      let rows = (this.tableHeight - 100) / 68
      // console.log('rows', rows)
      return Math.floor(rows) > 0 ? Math.floor(rows) : 1
    }
  },
  watch: {
    isLoadingDl(newVal) {
      if (newVal === false && this.firstLoading) {
        this.firstLoading = false
      }
      // console.log('isLoadingDl', newVal)
      this.isLoading = newVal

    },
    showColoumsDl: {
      handler(newVal) {
        this.sortCount += 1
        this.showColoums = newVal.filter(item => item !== 'project:project_set')
        // console.log('showColoumsDl',newVal,this.showColoums)

        // this.isLoading = false
        this.$nextTick(() => {
          this.$refs.eltable.doLayout()
        })
      },
      deep: true
    },
    projectListDl: {
      handler(newVal) {
        this.projectList = newVal
      },
      deep: true
    },
    sortColumnNameDl(newVal) {
      this.sortColumnName = newVal
      this.filterChange()
    },
    sortColumnOrderDl(newVal) {
      this.sortColumnOrder = newVal
      this.filterChange()
    },
    totalnumsDl(newVal) {
      this.totalnums = newVal
    },
    pagesizeDl(newVal) {
      this.pagesize = newVal
    },
    pageNumberDl(newVal) {
      // console.log('pageNumberDl变化',newVal)
      this.pageNumber = newVal
    },
    tableColumnCustomConfig:{
      handler(newVal){
        let poperRef = this.$refs[`unusual`+newVal['project:project_id'].project_id]
        // console.log('tableColumnCustomConfig change',newVal,poperRef)

        this.$nextTick(()=>{
          poperRef[1].updatePopper()
        })
      },
      deep:true
    }
  },
  methods: {

    split2Array(item){
      let arr
      if(item.includes(",")){
        arr = item.split(',')
      }else{
        arr = item.split('，')
      }
      // console.log('arrrrr',arr)
      return arr

    },
    sort(prop,order){
      this.$refs.eltable.sort(prop,order)
    },
    unusualShow(columnName,rowValue,show=true,row){
      // console.log('unusualShow',columnName,rowValue,row,show)
      // this.$nextTick(()=>{
      //   console.log('this.$refs.gridTable',this.$refs.gridTable)
      //   this.$refs.gridTable.doShow()
      //   //this.$refs.gridTable.doClose()
      // })

      this.$emit("unusualShow",rowValue)
      // setTimeout(()=>{
      //   this.$nextTick(()=> {
      //     console.log('this.$refs.unusual',this.$refs[`unusual`+rowValue])
      //     this.$refs[`unusual`+rowValue][1].updatePopper()
      //   })
      // },1000)
    },
    setHeight(){
      if(this.tableId==0||this.tableId==1){
        this.setHei(document.body.clientHeight - this.getCustomTabelHeightOffset)
      }else{
        // console.log('this.$refs.mycontentRef.clientHeight',this.$refs.mycontentRef.clientHeight)
        this.setHei(this.$refs.mycontentRef.clientHeight - 60)
      }
      // let he = document.body.clientHeight - this.getCustomTabelHeightOffset
      // let text = 'height:' + he + 'px;'
      // document.getElementsByClassName('plTableBox')[0].style.cssText = text
      // document.getElementsByClassName('plTableBox')[0].childNodes[0].style.cssText = text
    },

    setHei(val) {
      this.tableHeight = val
      // console.log('this.tableHeight',this.tableHeight,this.getCustomTabelHeightOffset,this.tableId)
    },

    refresh() {
      this.$nextTick(() => {
        this.setHeight()
        this.$refs.eltable.doLayout()
      })
    },
    currentChange(e) {
      this.$emit('current-change', e)
    },

    filterChange() {
      //表格渲染
      this.$nextTick(() => {
        if (this.sortColumnName !== '') {
          // console.log('this.$refs.eltable', this.$refs.eltable)
          this.$refs.eltable.sort(this.sortColumnName, this.sortColumnOrder + "ending")
        } else {
          this.$refs.eltable.clearSort()
        }
      })

    },

    filterChangeNow() {
      //表格渲染
      if (this.sortColumnName !== '') {
        // console.log('this.$refs.eltable', this.$refs.eltable)
        this.$refs.eltable.sort(this.sortColumnName, this.sortColumnOrder + "ending")
      } else {
        this.$refs.eltable.clearSort()
      }
    },


    //列拖拽排序
    columnDrop() {
      let table = document.getElementById('dltable' + this.tableId)
      // console.log('table',table)
      const wrapperTr = table.querySelector('.el-table__header-wrapper tr')
      // console.log('wrapperTr',wrapperTr)
      new Sortable(wrapperTr, {
        ghostClass: 'blue-background-class',
        animation: 180,
        delay: 0,
        forceFallback: true,
        onEnd: evt => {
          // console.log('columnDrop',evt)
          if (evt.oldIndex === evt.newIndex) return;
          const oldItem = this.showColoums[evt.oldIndex];
          this.showColoums.splice(evt.oldIndex, 1)//把需拖动表头移除
          this.showColoums.splice(evt.newIndex, 0, oldItem)//新增到新位置

          this.sortCount++
          //恢复原排序
          this.$nextTick(() => {
            if (this.sortColumnName !== '') {
              this.$refs.eltable.sort(this.sortColumnName, this.sortColumnOrder + "ending")
            } else {
              this.$refs.eltable.clearSort()
            }
          })


          // this.findSelsectChanged()
          //TODO:在父组件中findSelectChange
          this.$emit("column-drop", this.showColoums)
        }
      })
    },
    //-------------eltable触发-----------------
    sortChange(e) {//排序改变
      if (e.order === null) {
        this.sortColumnName = ""
        this.sortColumnOrder = ""
      } else {
        this.sortColumnName = e.prop
        if (e.order === 'ascending') {
          this.sortColumnOrder = 'asc'
        } else {
          this.sortColumnOrder = 'desc'
        }
      }

      this.$emit('sort-change', e)
    },
    rowClick(e) {
      this.$emit('row-click', e)
    },


    columnLabel(item) {
      if (this.column_mapper[item]) {
        // var x = this.column_mapper[item].slice(this.column_mapper[item].indexOf(':') + 1).slice(0, this.column_mapper[item].slice(this.column_mapper[item].indexOf(':') + 1).indexOf(':'))
        let splitMap = this.column_mapper[item].split(':')
        let x = splitMap[splitMap.length-2]

        // if (x.indexOf('(') !== -1) {
        //   return x.slice(0, x.indexOf('('))
        // }
        return x
      }
      return this.column_mapper[item]
    },
    columnLabelLast(item) {
      return ""
      if (this.column_mapper[item]) {
        // var x = this.column_mapper[item].slice(this.column_mapper[item].indexOf(':') + 1).slice(0, this.column_mapper[item].slice(this.column_mapper[item].indexOf(':') + 1).indexOf(':'))
        let splitMap = this.column_mapper[item].split(':')
        let x = splitMap[splitMap.length-2]

        if (x.indexOf('(') !== -1) {
          return x.slice(x.indexOf('('))
        }
        return ''
      }
      return this.column_mapper[item]
    },
    columnsfixed(item){
      if(this.customColumnWidth){
        if (this.customColumnWidth.hasOwnProperty(item)) {//汇总的日期类的固定宽度
          // console.log('宽度')
          return this.customColumnWidth[item]+'px'
        }
      }

    },

    columnsMin(item) {
      // console.log('columnsMin:item',item)
      let min =  142
      if (item && JSON.stringify(this.column_mapper) !== "{}") {
        // console.log('this.column_mapper[item]',this.column_mapper[item],item)

        let splitMap = this.column_mapper[item].split(':')
        let x = splitMap[splitMap.length-2]

        let i = x
        if (i.length * 25 > min) {
          min = i.length * 23
        }
      }
      if (item === 'project:project_name') {
        return '230px'
      } else if (item === 'project:project_id') {
        return '120px'
      }else if(item === 'project_id_name'){
        return '200px'
      } else if (item.split(':')[0] === 'date') {//汇总的日期类的固定宽度
        return '130px'
      } else if (item=='user_name'||item=='request_count'||item=='query_count') {//汇总的日期类的固定宽度
        // console.log('宽度')
        return '130px'
      } else {
        return min
      }
    },

    // columnsMin(item) {
    //   // console.log('columnsMin:item',item)
    //   let min = this.tableId==0 ? 142 : 142
    //   if (item && JSON.stringify(this.column_mapper) !== "{}") {
    //     console.log('this.column_mapper[item]',this.column_mapper[item],item)
    //
    //     let splitMap = this.column_mapper[item].split(':')
    //     let x = splitMap[splitMap.length-2]
    //
    //     let i = x
    //     if (x.indexOf('(') !== -1) {
    //       i = x.slice(0, x.indexOf('('))
    //     }
    //     let j = x
    //     if (x.indexOf('(') !== -1) {
    //       j = x.slice(x.indexOf('('))
    //     }
    //     if (i.length * 25 > min || (j.length - 2) * 25 > min) {
    //       min = Math.max(i.length * 23, (j.length - 2) * 23)
    //       if (i === j) {
    //         min = 142
    //       }
    //     }
    //   }
    //   if (item === 'project:project_name') {
    //     return '230px'
    //   } else if (item === 'project:project_id') {
    //     return '120px'
    //   }else if(item === 'project_id_name'){
    //     return '200px'
    //   } else if (item.split(':')[0] === 'date') {//汇总的日期类的固定宽度
    //     return '130px'
    //   } else if (item=='user_name'||item=='request_count'||item=='query_count') {//汇总的日期类的固定宽度
    //     console.log('宽度')
    //     return '130px'
    //   } else {
    //     return min
    //   }
    // },
    // toQfNumberClass(totype, value, scrop){
    //   // console.log('totype, value,scrop',totype, value,scrop)
    //   if(totype==this.showColoums[0]){
    //     // console.log('totype',totype)
    //       let tbodys = document.querySelectorAll('#dltable1 .el-table__fixed tr.el-table__row')
    //       // console.log('el-tbodys',tbodys)
    //       let sumRow = tbodys[scrop.$index]
    //     if(sumRow){
    //       console.log('sumRow',sumRow.innerText)
    //       if(sumRow.innerText.indexOf("小计") != -1){
    //         return 1
    //       }
    //     }
    //   }
    //   return 0
    // },
    toQfNumber(totype, value, scrop) {
      // console.log('totype, value,scrop',totype, value,scrop)
      // if(scrop.$index===0){
      //   // console.log('scrop',scrop)
      //   let tbodys = document.querySelectorAll('#dltable1 .el-table__fixed tr.el-table__row')
      //   // console.log('el-tbodys',tbodys)
      //   let sumRow = tbodys[0]
      //   // sumRow.setAttribute("style", "border-left:solid #000000 10px;")
      //   console.log('sumRow',sumRow)
      //
      // }
      let type = this.column_mapper[totype].slice(this.column_mapper[totype].lastIndexOf(':') + 1)

      // 更多-发奖账户管理 3张表 数值字段 保留两位小数
      if (['client_name', 'platform', 'project'].includes(this.tableId)) {
        if (type === "decimal" || type === 'int') {
          if (value === undefined || value === null || value === '' || isNaN(Number(value))) return value
          return Number(value).toFixed(2)
        }
        return value
      }

      if (type === "decimal" || type === 'int') {
        if (value === undefined) {
          return -1
        }

        let nums = Number(value).toFixed(2).toString().split('.')
        nums[0] = parseFloat(nums[0]).toLocaleString()
        return nums.join('.')
        // return type === "decimal" ? nums.join('.') : nums[0]
      }
      return value
    },
    //---------------------样式控制start-----------------
    /**
     * 表格头部样式
     * @param row
     * @param column
     * @param rowIndex
     * @param columnIndex
     * @returns {{fontFamily: string, whiteSpace: string, color: string, textAlign: string, background: string, fontSize: string, boxSizing: string, paddingLeft: string, fontWeight: string, height: string}}
     */
    headCellStyle({row, column, rowIndex, columnIndex}) {
      // console.log(column.property)
      // console.log(this.column_mapper[column.property])
      if(!this.projectList.length) return
      if (this.column_mapper[column.property]) {
        var type = this.column_mapper[column.property].slice(this.column_mapper[column.property].lastIndexOf(':') + 1)


        let fixedHeader = false

        if(this.fixedColumns.indexOf(column.property)!==-1){
          fixedHeader = true
        }


        if (type === 'decimal' || type === 'int') {
          // if(JSON.stringify(this.projectList[rowIndex]).indexOf('总计')!==-1 && column==0){
          //   console.log('this.projectList[rowIndex],type,column',this.projectList[rowIndex],type,column)
          // }

          return {
            cursor: (fixedHeader||this.disableDrag) ? 'no-drop': 'grab',
            height: '48px',
            background: '#F5F7FA',
            textAlign: 'right',
            fontFamily: 'SourceHanSansSC-Regular, SourceHanSansSC',
            color: '#3F464E',
            fontWeight: '600',
            fontSize: '14px',
            paddingLeft: '4px',
            boxSizing: "border-box",
            whiteSpace: "pre"
          }
        } else {
          return {
            cursor: (fixedHeader||this.disableDrag) ? 'no-drop':'grab',
            height: '48px',
            background: '#F5F7FA',
            textAlign: 'left',
            fontFamily: 'SourceHanSansSC-Regular, SourceHanSansSC',
            color: '#3F464E',
            fontWeight: '600',
            fontSize: '14px',
            paddingLeft: '4px',
            boxSizing: "border-box",
            whiteSpace: "pre"
          }
        }
      } else if (column.property == 'exportBtn') {
        return {
          cursor: 'no-drop',
          height: '48px',
          background: '#F5F7FA',
          textAlign: 'left',
          fontFamily: 'SourceHanSansSC-Regular, SourceHanSansSC',
          color: '#3F464E',
          fontWeight: '600',
          fontSize: '12px',
          paddingLeft: '4px',
          boxSizing: "border-box",
          whiteSpace: "pre"
        }
      }
    },

    rowStyle({row, column, rowIndex, columnIndex}){
      if(this.tableId==1){
        if(rowIndex==0){
          return 'border-left:solid #6C7B91 6px !important;'
        }else if(JSON.stringify(this.projectList[rowIndex]).indexOf('小计')!==-1){
          return 'border-left:solid #A5AEC1 6px !important;'
        }else{
          // if(rowIndex%2==0){
          //   return 'border-left:solid transparent 6px !important;'
          // }else {
          //   return 'border-left:solid #F6F8FB 6px !important;'
          // }

        }
      }

    },

    /**
     * 表格每一列的样式
     * @param row
     * @param column
     * @param rowIndex
     * @param columnIndex
     * @returns {{fontFamily: string, color: string, textAlign: string, fontSize: string, boxSizing: string, lineHeight: string, paddingLeft: string, fontWeight: string, height: string}|{fontFamily: string, color: string, textAlign: string, paddingRight: string, fontSize: string, boxSizing: string, lineHeight: string, paddingLeft: string, fontWeight: string, height: string}}
     */
    cellStyleMethod({row, column, rowIndex, columnIndex}) {
      if (this.column_mapper[column.property]) {
        var type = this.column_mapper[column.property].slice(this.column_mapper[column.property].lastIndexOf(':') + 1)
        // console.log('this.column_mapper[column.property]',this.column_mapper[column.property])
        let fontWeight = 400
        if(this.tableId==1){
          if(rowIndex==0){
            fontWeight = 'bold'
          }else if(JSON.stringify(this.projectList[rowIndex]).indexOf('小计')!==-1){
            fontWeight = 'bold'
          }
        }


        // console.log(type)
        if (type === 'decimal' || type === 'int') {
          return {
            height: '48px',
            // background: rowIndex%2===0?'#FFFFFF':'#F6F8FB',
            textAlign: 'right',
            fontFamily: 'Helvetica',
            color: '#3F464E',
            fontWeight: fontWeight,
            fontSize: '12px',
            paddingRight: '10px',
            paddingLeft: '4px',
            boxSizing: "border-box",
            lineHeight: "17px",
            paddingTop:'0px',
            paddingBottom:'0px'

          }
        } else {
          return {
            height: '48px',
            // background: rowIndex%2===0?'#FFFFFF':'#F6F8FB',
            textAlign: 'left',
            fontFamily: 'Helvetica',
            color: '#3F464E',
            fontWeight: fontWeight,
            fontSize: '12px',
            paddingLeft: '4px',
            boxSizing: "border-box",
            lineHeight: "17px",
            paddingTop:'0px',
            paddingBottom:'0px'
          }
        }
      }
    },
    //---------------------样式控制end-----------------
  }
}
</script>

<style lang="scss">

.el-popover.unusual-popover{
  width:430px;
  background-color:#DCDFE6;
  padding:16px;
  font-size: 12px;
  box-shadow: none !important;
  border:none;
  -webkit-box-shadow:none;
  border-radius: 4px;
}

.unusual-popover[x-placement^=left] .popper__arrow::after{
  border-left-color: #DCDFE6;
}
.unusual-popover[x-placement^=right] .popper__arrow::after{
  border-right-color: #DCDFE6;
}
.unusual-popover[x-placement^=bottom] .popper__arrow::after{
  border-bottom-color: #DCDFE6;
}
.unusual-popover[x-placement^=top] .popper__arrow::after{
  border-top-color: #DCDFE6;
}

.el-popover.unusual-popover-none{
  width:430px;
  background-color:transparent;
  padding:16px;
  font-size: 12px;
  box-shadow: none !important;
  border:none;
  -webkit-box-shadow:none;
  border-radius: 4px;
}

.unusual-popover-none[x-placement^=left] .popper__arrow::after{
  border-left-color: transparent;
}
.unusual-popover-none[x-placement^=right] .popper__arrow::after{
  border-right-color: transparent;
}
.unusual-popover-none[x-placement^=bottom] .popper__arrow::after{
  border-bottom-color: transparent;
}
.unusual-popover-none[x-placement^=top] .popper__arrow::after{
  border-top-color: transparent;
}



.el-table th.is-leaf{
}



.cellCls{
  background-color: #E4E9F4;
}
.cellClsN{
  background-color: white;
}
.sumLeftBorder{
  height: 100%;
  width: 10px;
  background-color: #6C7B91;
  position: absolute;
  top: 0px;
  left: 0px;

}
/*表格最外边框*/
//.el-table--border, .el-table--group {
//  border: none;
//}


.el-table__fixed {
  height: calc(100% - 10px) !important; //设置高优先，以覆盖内联样式
  // background: red;
}
.el-table__fixed-right {
  height: calc(100% - 10px) !important; //设置高优先，以覆盖内联样式
  // background: red;
}
.el-table__fixed-right-patch{
  background-color: #E4E9F4;
}

//.el-table tr > th {
//  border: none;
//}

.el-table tr {
  //禁用hover
  //pointer-events: none;
}

.el-table th > .cell {
  width: unset !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap !important;
  word-break: break-all;
  line-height: 23px;
  padding-left: 10px;

}

.el-table th div > div {
  text-align: right;
  overflow: hidden;
  white-space: normal !important;
  word-break: break-all;
  line-height: 23px;
  padding: 0;
}

.el-table .pl-table-beyond > div {
  white-space: normal !important;
}

//带排序和不带排序的表头区别
#dltable0{
  .el-table th > .cell div {
    width: unset;
    padding-right: 10px;
  }
}

.sortableClass{
  .el-table th > .cell div {
    width: unset;
    padding-right: 10px;
  }
}

#dltable1{
  .el-table th > .cell div {
    width: unset;
  }
}


.el-table .caret-wrapper {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

// ::v-deep(.el-table__fixed-body-wrapper){
//   top:80
// }
.el-table__body-wrapper::-webkit-scrollbar {
  width: 10px !important;
  height: 10px !important;
  background-color: #F5F5F5;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  width: 1px;
  border-radius: 3px;
  background: rgba(165, 174, 193, 0.7);
  // opacity: 0.7;
  // height:30px;
}

//.el-table__body-wrapper{
//
//}

//.el-table__body tr {
//  pointer-events: none;
//}

//鼠标hover行的颜色
.el-table__body tr:hover > td {
  background: #EBF3FF !important;
  //border-left: 6px solid #EBF3FF;
  //border: none;
}

//.el-table__body tr > td {
//  // background: #EBF3FF;
//  border: none;
//}

.el-table__row > td {
  border-color: transparent;
  border-width: 0px;
  border-left: none;
  border-right: none;
  //border: none !important;
}



//表头的排序按钮
.plTableBox .el-table .caret-wrapper{
  position: absolute !important;
}


#dltable0{
  .el-table__row {
    background: #FFFFFF;
    //border: none;

    //偶数行
    &:nth-child(2n) {
      background: #F6F8FB;
    }
    //奇数行
    &:nth-child(2n+1) {
      background: white;
    }
  }

  .el-table__row td > .cell {
    //width: 100% !important;
    padding-right: 20px;
    width: 100% !important;
    position: initial !important;
    //background-color: green;
  }
}

#dltable1{
  .el-table__row {
    background: #FFFFFF;
    //border: none;

    //偶数行
    &:nth-child(2n) {
      background: #F6F8FB;
      border-left: 6px solid #F6F8FB;
    }
    //奇数行
    &:nth-child(2n+1) {
      background: white;
      border-left: 6px solid white;
    }

    // &:hover{
    //   background: red !important;
    // }
  }

  .el-table__row td > .cell {
    //width: 100% !important;
    padding-right: 0px;
    width: 100% !important;
    position: initial !important;
    //background-color: green;
  }
}


//翻页按钮箭头对齐
.el-pagination .btn-next .el-icon {
  margin: auto;
}

.el-pagination .btn-prev .el-icon {
  margin: auto;
}

//test
.el-table__body-wrapper {
  overflow: inherit;
}

//让table能加border
.el-table__body {
  border-collapse: collapse;
  display: inherit;
}

//.row-style{
//  border: 1px solid #409EFF;
//  box-shadow: inset 0px 0px 6px 0px rgba(64, 158, 255, .6);
//}
//.cell-style{
//  border-bottom: 1px solid  #409EFF;
//}

.detail-text-2{
  display: flex;
  align-items:center;
  color: black;
  font-size:14px;
}

</style>
